import styled from "styled-components";
export const SeparatorContainer = styled.div`
  margin: 32px 0;
  position: relative;
  h4 {
    position: relative;
    background: #fff;
    display: inline;
    padding-left: 16px;
  }
  &:before {
    background-color: #acb4b4;
    content: "";
    display: block;
    height: 1px;
    width: 100%;
    position: absolute;
    right: 0;
    top: 50%;
  }
`;
